import React from "react"
import PropTypes from 'prop-types'
import {findDOMNode} from "react-dom"
import PopoverComponent from "../../base-component/popover-component"

import HintPopover from "src/core/gd-ui/hint-popover/hint-popover"

import Popover from 'src/core/gd-components/gd-popover/popover'
import DateRangeCalendar from './components/daterange-calendar'
import formatDate from "../../../gd/format/date";
import ControlButtonStandard from "../../buttons/control-button/control-button-standard"

export default class DateRangePicker extends PopoverComponent {

    static propTypes = {
        isOpen                  : PropTypes.bool,
        placeholder             : PropTypes.string,
        value                   : PropTypes.object,

        form                    : PropTypes.object,
        startName               : PropTypes.string,
        endName                 : PropTypes.string,

        minDate                 : PropTypes.object,
        maxDate                 : PropTypes.object,

        presets                 : PropTypes.array,

        dateFormat              : PropTypes.string,

        size                    : PropTypes.string,
        type                    : PropTypes.oneOf([
            'default', 'top', 'top-extended', 'inline', 'form', 'form-default','form-default-icon', 'text-14',
            'text-normal', 'text-13', 'text-12', 'text-11', 'inline-icon', 'control-button', 'func']),
        iconOnly                : PropTypes.bool,
        noIcon                  : PropTypes.bool,
        disabled                : PropTypes.bool,

        btnNoValue              : PropTypes.bool,
        btnNoValueLabel         : PropTypes.string,

        hint                    : PropTypes.string,

        // underline
        underlined              : PropTypes.oneOf(['on-hover', 'always', 'never']),  // if set will show border bottom for the value

        popoverAttachment       : PropTypes.string,
        popoverTargetAttachment : PropTypes.string,
        popoverTargetOffset     : PropTypes.string,
        attachmentType          : PropTypes.string,
        tetherConstraints       : PropTypes.array,

        renderFunc              : PropTypes.func,
        onTogglePopover         : PropTypes.func,
        onChange                : PropTypes.func,
        onUserSelect            : PropTypes.func
    }

    static defaultProps = {
        size                    : "small",
        type                    : "default",
        iconOnly                : false,
        isOpen                  : false,
        placeholder             : "Please select",

        underlined              : 'on-hover',

        popoverTargetOffset     : "0 0",
        popoverAttachment       : 'top left',
        popoverTargetAttachment : 'bottom left',
        attachmentType          : "horizontal",
        presets                 : null,

        dateFormat              : 'MMM DD'
    };

    constructor(props) {

        super(props)

        if (this.props.form) {
            this.props.form.registerFormComponent(this.props.startName,this)
            this.props.form.registerFormComponent(this.props.endName,this)
        }

        this.state = {
            value: this._initValue(props)
        }
    }

    componentDidMount(){
        if(this.props.isOpen) {
            this.setState({isOpen: true})
        }
    }

    UNSAFE_componentWillUpdate(nextProps, nextState){
        if (!_.isEqual(nextState.value,this.state.value)) {
            this.handleChangeItem(nextState.value);
        }
    }

    UNSAFE_componentWillReceiveProps( nextProps ) {
        this.setState({
            value: this._initValue(nextProps)
        });
    }

    shouldComponentUpdate( nextProps, nextState ) {
        return !( _.isEqual(nextProps, this.props) && _.isEqual(nextState, this.state) )
    }

    _initValue(props) {
        return props.form && props.form.getValue(props.startName) ? Moment.range(
            Moment(props.form.getValue(props.startName)),
            props.form.getValue(props.endName) ? Moment(props.form.getValue(props.endName)) : Moment(props.form.getValue(props.startName))
        ) : props.value
    }

    getValue = () => this.state.value

    onDateRangeSelected = (range) => {
        // range is a moment range object
        if (this.props.form) {
            this.props.form.onFormComponentValueChange(this.props.startName,range ? range.start : null)
            this.props.form.onFormComponentValueChange(this.props.endName,range ? range.end : null)
        }

        this.setState({
            value: range
        }, ()=> {
            this.hidePopover()
            this.handleSelectItem(range)
        });
    }

    handleChangeItem = (range) => {if (this.props.onChange) this.props.onChange(range)}
    handleSelectItem = (range) => {if (this.props.onUserSelect) this.props.onUserSelect(range)}

    renderPopover() {
        if (this.state.showPopover) {
            const presets = _.compact([].concat(this.props.presets))
            if (this.props.btnNoValue) {
                presets.push(
                    {label: this.props.btnNoValueLabel, onClick: ()=>{this.onDateRangeSelected(null)}}
                )
            }

            return (
                <Popover popoverClass       = "daterange-picker-popover"
                         className          = "daterange-picker-popover-container"
                         attachment         = {this.props.popoverAttachment}
                         targetAttachment   = {this.props.popoverTargetAttachment}
                         targetOffset       = {this.props.popoverTargetOffset}
                         attachmentType     = {this.props.attachmentType}
                         constraints        = {this.props.tetherConstraints}
                         getTargetFunc      = {()=>findDOMNode(this)}
                         onClickOutside     = {()=>{this.hidePopover()}}>
                    <DateRangeCalendar className        = "daterange-picker-calendar"
                                       presets          = {presets}
                                       selectedRange    = {this.state.value}
                                       minDate          = {this.props.minDate}
                                       maxDate          = {this.props.maxDate}
                                       onSelect         = {this.onDateRangeSelected}/>
                </Popover>
            )
        }

        return null
    }

    renderValue() {

        let valueItem = this.props.placeholder
        if (this.state.value) {
            // valueItem = "{0} - {1}".f(this.state.value.start.format(this.props.dateFormat), this.state.value.end.format(this.props.dateFormat))
            valueItem = "{0} - {1}".f(
                formatDate(this.state.value.start, this.props.dateFormat),
                formatDate(this.state.value.end, this.props.dateFormat)
            )
        }

        const curValueClasses = Classes('gd-daterange-control', {
            'no-value': !this.state.value
        })

        switch (this.props.type) {
            case 'inline':
                return (
                    <div className={Classes(curValueClasses, "ui5-circle-selector")} onClick={!this.props.disabled ? this.togglePopover : null}>
                        <div className="icon i5-calendar"/>
                        {!!this.state.value && valueItem}
                    </div>
                )
            case 'form-default-icon':

                return (
                    <div className={"gd-daterange-control flex-row-between-center"} onClick={!this.props.disabled ? this.togglePopover : null}>
                        <div className="flex-row-left-center">
                            <div className="icon i5-calendar p-l-10 ui5-ico-14"/>
                            <div className="gd-daterange-value">
                                {!this.props.iconOnly && valueItem}
                            </div>
                        </div>
                        {/*<div className="i5-big-angle-down fs-9 ui5-color-not-important p-r-15"/>*/}
                    </div>
                )

            case 'inline-icon':
                return (
                    <div className={curValueClasses} onClick={!this.props.disabled ? this.togglePopover : null}>
                        <div className="picker-icon  i5-calendar"/>
                        {!!this.state.value && valueItem}
                    </div>
                )

            case 'func': return this.props.renderFunc(this.props, this.state, this.togglePopover)

            case 'control-button':
                return (
                    <ControlButtonStandard iconClass    = "i5-calendar"
                                           isDisabled   = {this.props.disabled}
                                           onClick      = {!this.props.disabled ? this.togglePopover : null}/>
                )

            default: {
                const classes = Classes(curValueClasses, {
                    'underlined-never'                      : this.props.disabled,
                    ['underlined-'+this.props.underlined]   : !this.props.disabled
                })

                return (
                    <div className={classes} onClick={!this.props.disabled ? this.togglePopover : null}>
                        <div className="gd-daterange-value">
                            {!this.props.iconOnly && valueItem}
                        </div>
                        {!this.props.noIcon && <div className=" i5-calendar"/>}
                    </div>
                )
            }
        }
    }

    render() {

        const selectClassName = Classes('gd-daterange-picker', this.props.type+"-type", this.props.className, {
            [this.props.size]   : this.props.type !== 'inline',
            'disabled'          : this.props.disabled,
            'icon-only'         : this.props.iconOnly,
            'show-popover'      : this.state.showPopover
        });

        return (
            <div className={selectClassName}>
                {this.renderValue()}
                {this.renderPopover()}
                {!this.state.showPopover && <HintPopover parent={this} hint={this.props.hint}/>}
            </div>
        )
    }
}
